module.exports = __webpack_public_path__ + "static/image12-e4e1033f32de7eeea77b4814014ccfa7.png";